import React, { Component } from 'react';
import Modal from 'react-bootstrap4-modal';

import './ApiKeyForm.css';

class ApiKeyForm extends Component {
  constructor(props) {
      super(props);

      this.state = {
          visibility: false,
          apiKey: props.apiKey
      }

      this.hide = this.hide.bind(this);
      this.show = this.show.bind(this);
      this._handleApiKeyChange = this._handleApiKeyChange.bind(this);
      this._handleSubmit = this._handleSubmit.bind(this);
  }

  hide() {
      this.setState({ visibility: false });
  }

  show() {
      this.setState({ visibility: true });
  }

  _handleApiKeyChange(event) {
      this.setState({ apiKey: event.target.value });
  }

  _handleSubmit() {
    this.hide();
    
    if (this.props.onSubmit != null) {
        const { apiKey } = this.state;

        let event = new Event('submit');
        event.detail = {
            apiKey: apiKey
        };

        this.props.onSubmit(event);
    }
  }

  render() {
      const { visibility, apiKey } = this.state;

      return(
          <Modal visible={ visibility } onClickBackdrop={ this.hide }>
              <div className="modal-header">
                  <h5 className="modal-title">Change API Key</h5>
              </div>
              <div className="modal-body">
                  <div className="form-row">
                      <div className="form-group offset-md-2 col-md-8 col-sm-12 align-self-center">
                          <label>API Key</label>
                          <input type="text" className="form-control" placeholder="API Key" value={ apiKey } onChange={ this._handleApiKeyChange }></input>
                      </div>
                  </div>
              </div>
              <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={ this.hide }>
                      Cancel
                  </button>
                  <button type="button" className="btn btn-primary" onClick={ this._handleSubmit }>
                      Save
                  </button>
              </div>
          </Modal>
      );
  }
}

export default ApiKeyForm;


// WEBPACK FOOTER //
// ./src/_components/api_key_form/ApiKeyForm.jsx